var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":"","sm6":"","md4":"","offset-xs2":"","offset-sm3":"","offset-md4":""}},[_c('IdentityProviders')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }